import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material'
import IconMore from '@mui/icons-material/More'
import AutorenewIcon from '@mui/icons-material/Autorenew'

import { putTriggerHaynesProLinker } from '../state/actions'
import { IMessageState } from './HaynesProMessage'

interface IProps {
  distributorUUID: string
  disabled: boolean
  disableRenewLicenses: boolean
  handleRenewLicenses: () => void
  onLinkerStart: (message: IMessageState) => void
  onLinkerError: (message: IMessageState) => void
  onLinkerFinish: (message: IMessageState) => void
}
export const HaynesProMoreActionsMenu = ({
  distributorUUID,
  disabled,
  onLinkerStart,
  onLinkerError,
  onLinkerFinish,
  handleRenewLicenses,
  disableRenewLicenses
}: IProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLinkLicenses = async () => {
    handleClose()
    onLinkerStart({ content: t('haynespro.start_haynes_pro_linker'), severity: 'info' })
    try {
      const data = await dispatch(putTriggerHaynesProLinker(distributorUUID))
      onLinkerFinish({
        content: `${t('haynespro.finish_haynes_pro_linker')} ${t('haynespro.message_linked_stats', data.Data)}`,
        severity: 'success'
      })
    } catch {
      onLinkerError({ content: t('haynespro.error_haynes_pro_linker'), severity: 'error' })
    }
  }

  return (
    <div>
      <IconButton
        edge='end'
        color='inherit'
        disabled={disabled}
        onClick={handleClick}
        data-testid='btn-haynespro-actions-menu'
        size='large'
      >
        <IconMore />
      </IconButton>
      <Menu id='simple-menu' anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleRenewLicenses} disabled={disableRenewLicenses} data-testid='btn-renew-selected-licenses'>
          <ListItemIcon>
            <AutorenewIcon />
          </ListItemIcon>
          {t('haynespro.renew_selected')}
        </MenuItem>
        <MenuItem onClick={handleLinkLicenses}>{t('haynespro.link_all_licenses')}</MenuItem>
      </Menu>
    </div>
  )
}

export default HaynesProMoreActionsMenu
